import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const ChangePasswordComplete = gql`
  mutation ChangePasswordComplete($input: ChangePasswordCompleteInput!) {
    changePasswordComplete(input: $input) {
      ... on ChangePasswordCompleteSuccess {
        code
        __typename
      }

      ... on ChangePasswordNewPasswordInvalid {
        ...error
        __typename
      }

      ... on ChangePasswordError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;
